export default {
  placeholder: 'Rechercher',
  cancel: 'Annuler',
};
